import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { DisplayDrawerContext } from "../../../../layout/DisplayDrawerContext";
import { useTradeByBrokersReportFilter } from "../../../../data/reports/exchbusiness/tradeByBrokers/hooks/useTradeByBrokersReportFilter";
import { LocalizationContext } from "../../../../core/localization/Localization";
import { CustomTooltip } from "../../../components/common/CustomTooltip";
import { TradeByBrokersFilterEditor } from "./TradeByBrokersEditor";

export const TradeByBrokersReportFilter: React.FunctionComponent = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const showFilter = React.useCallback(
    () => showWithDrawer(<TradesByBrokersFilterEditor />),
    [showWithDrawer]
  );

  const [filter, editfilter, save] = useTradeByBrokersReportFilter();
  const { getString } = React.useContext(LocalizationContext);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <CustomTooltip titleKeyword="filterTooltip">
          <IconButton color="secondary" component="span" onClick={showFilter}>
            <FilterIcon />
          </IconButton>
        </CustomTooltip>
      </Grid>
    </Grid>
  );
};

const TradesByBrokersFilterEditor: React.FunctionComponent = () => {
  const [filter, editFilter, save] = useTradeByBrokersReportFilter();
  return (
    <TradeByBrokersFilterEditor
      filter={filter}
      editFilter={editFilter}
      save={save}
    />
  );
};
